/* Jeetinder Sandhu — theme scripts */
(function(){
'use strict';
var $=function(s,c){return (c||document).querySelector(s)}, $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
var mq=window.matchMedia('(min-width: 990px)');

var _decoder=document.createElement('textarea');
function cleanFormat(f){_decoder.innerHTML=String(f||'');var s=_decoder.value;var d=document.createElement('div');d.innerHTML=s;return (d.textContent||'').replace(/\s+/g,' ').trim()}
function money(cents){
  var fmt=cleanFormat((window.JS&&JS.moneyFormat)||'₹{{amount}}')||'₹{{amount}}';
  function f(n,d,t,dec){n=(n/100).toFixed(d);var p=n.split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,t);return p[1]?p[0]+dec+p[1]:p[0];}
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/,function(m,k){
    if(k==='amount_no_decimals')return f(cents,0,',','.');
    if(k==='amount_with_comma_separator')return f(cents,2,'.',',');
    if(k==='amount_no_decimals_with_comma_separator')return f(cents,0,'.',',');
    if(k==='amount_with_apostrophe_separator')return f(cents,2,"'",'.');
    return f(cents,2,',','.');
  });
}
function lock(on){document.body.classList.toggle('is-locked',!!on)}

/* Header compact */
var header=$('[data-header]');
if(header){var setH=function(){document.documentElement.style.setProperty('--hdr-live',header.getBoundingClientRect().height+'px')};var onS=function(){header.classList.toggle('is-compact',window.scrollY>40);setTimeout(setH,520)};window.addEventListener('scroll',onS,{passive:true});window.addEventListener('resize',setH);onS();setH();}

/* Mobile menu */
var mm=$('[data-mobile-menu]');
$$('[data-menu-open]').forEach(function(b){b.addEventListener('click',function(){mm.classList.add('is-open');mm.setAttribute('aria-hidden','false');lock(true);$$('.mobile-menu__link',mm).forEach(function(l,i){l.style.transitionDelay=(80+i*50)+'ms'})})});
$$('[data-menu-close]').forEach(function(b){b.addEventListener('click',function(){mm.classList.remove('is-open');mm.setAttribute('aria-hidden','true');lock(false)})});
if(mm)$$('a',mm).forEach(function(a){a.addEventListener('click',function(){mm.classList.remove('is-open');lock(false)})});

/* Footer accordions */
function footerMode(){$$('.site-footer__col').forEach(function(d,i){if(mq.matches)d.open=true;else d.open=d.hasAttribute('data-open-first')})}
footerMode();mq.addEventListener&&mq.addEventListener('change',footerMode);

/* Hero slider */
$$('[data-hero]').forEach(function(hero){
  var slides=$$('[data-slide]',hero),bars=$$('[data-hero-go]',hero),count=$('[data-hero-count]',hero),cap=$('[data-hero-caption]',hero);
  var n=slides.length,idx=0,timer=null,paused=false,sec=parseInt(hero.getAttribute('data-interval'),10)||6;
  hero.style.setProperty('--hero-int',sec+'s');
  if(n<2)return;
  function pad(x){return (x<10?'0':'')+x}
  function go(i){
    i=(i+n)%n;var prev=idx;idx=i;
    slides.forEach(function(s,k){s.classList.toggle('was-active',k===prev&&k!==i);s.classList.remove('is-active')});
    void slides[i].offsetWidth;slides[i].classList.add('is-active');
    bars.forEach(function(b,k){b.classList.remove('is-on');b.classList.toggle('is-done',k<i)});
    requestAnimationFrame(function(){requestAnimationFrame(function(){bars[i]&&bars[i].classList.add('is-on')})});
    if(count)count.textContent=pad(i+1)+' / '+pad(n);
    if(cap)cap.textContent=slides[i].getAttribute('data-caption')||'';
    restart();
  }
  function restart(){clearInterval(timer);timer=setInterval(function(){if(!paused&&!document.hidden)go(idx+1)},sec*1000)}
  bars.forEach(function(b){b.addEventListener('click',function(){go(parseInt(b.getAttribute('data-hero-go'),10))})});
  var p=$('[data-hero-prev]',hero),nx=$('[data-hero-next]',hero);
  p&&p.addEventListener('click',function(){go(idx-1)});nx&&nx.addEventListener('click',function(){go(idx+1)});
  hero.addEventListener('mouseenter',function(){paused=true});hero.addEventListener('mouseleave',function(){paused=false});
  var x0=null;hero.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
  hero.addEventListener('touchend',function(e){if(x0===null)return;var d=e.changedTouches[0].clientX-x0;if(Math.abs(d)>40)go(idx+(d<0?1:-1));x0=null});
  go(0);
  if(window.Shopify&&Shopify.designMode){document.addEventListener('shopify:block:select',function(e){var k=slides.indexOf(e.target);if(k>-1){go(k);paused=true}});document.addEventListener('shopify:block:deselect',function(){paused=false})}
});

/* Horizontal scrollers */
$$('[data-hscroll]').forEach(function(t){
  var sec=t.closest('section');if(!sec)return;
  var step=function(){var c=t.firstElementChild;return c?c.getBoundingClientRect().width+40:t.clientWidth};
  var p=$('[data-scroll-prev]',sec),n=$('[data-scroll-next]',sec);
  p&&p.addEventListener('click',function(){t.scrollBy({left:-step(),behavior:'smooth'})});
  n&&n.addEventListener('click',function(){t.scrollBy({left:step(),behavior:'smooth'})});
});

/* Reveal on scroll */
if('IntersectionObserver' in window&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
  $$('.section-head, .split__text, .bespoke__head, .step, .piece, .card, .tile, .studio__text, .pstory__head, .newsletter, .cta-black > *').forEach(function(el){if(el.getBoundingClientRect().top>window.innerHeight){el.classList.add('reveal');io.observe(el)}});
}

/* Modals */
$$('[data-open-modal]').forEach(function(b){b.addEventListener('click',function(){var m=$('[data-modal="'+b.getAttribute('data-open-modal')+'"]');if(m){m.classList.add('is-open');lock(true)}})});
$$('[data-close-modal]').forEach(function(b){b.addEventListener('click',function(){var m=b.closest('[data-modal]');m.classList.remove('is-open');lock(false)})});

/* Cart drawer */
var drawer=$('[data-cart-drawer]');
function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
function imgUrl(u,w){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width='+w}
function renderCart(cart){
  if(!drawer)return;
  $$('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count});
  var list=$('[data-cart-items]',drawer),empty=$('[data-cart-empty]',drawer);
  $('[data-cart-subtotal]',drawer).textContent=money(cart.total_price);
  empty.hidden=cart.item_count>0;$('.drawer__foot',drawer).style.display=cart.item_count>0?'':'none';
  list.innerHTML=cart.items.map(function(it){
    var variant=(it.product_has_only_default_variant||!it.variant_title)?'':'<span class="small muted">'+esc(it.variant_title)+'</span>';
    return '<div class="line" data-key="'+esc(it.key)+'">'+
      '<a href="'+esc(it.url)+'" class="line__img ivory">'+(it.image?'<img src="'+esc(imgUrl(it.image,300))+'" alt="'+esc(it.product_title)+'" class="contain multiply" loading="lazy">':'')+'</a>'+
      '<div class="line__info"><div><div class="line__top"><a href="'+esc(it.url)+'" class="eyebrow strong">'+esc(it.product_title)+'</a><span>'+money(it.final_line_price)+'</span></div>'+variant+'</div>'+
      '<div class="line__bottom"><div class="line__qtybox"><button type="button" data-q="'+(it.quantity-1)+'" aria-label="Decrease">&minus;</button><span>'+it.quantity+'</span><button type="button" data-q="'+(it.quantity+1)+'" aria-label="Increase">+</button></div>'+
      '<button type="button" class="line__remove eyebrow muted u" data-q="0">Remove</button></div></div></div>';
  }).join('');
}
function fetchCart(){return fetch(JS.routes.cart+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){renderCart(c);return c})}
function openCart(){if(!drawer)return;fetchCart();drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');lock(true)}
function closeCart(){if(!drawer)return;drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');lock(false)}
window.JSCart={open:openCart,close:closeCart,refresh:fetchCart};
if(drawer&&document.body.className.indexOf('template-cart')===-1){
  $$('[data-cart-open]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();openCart()})});
}
$$('[data-cart-close]').forEach(function(b){b.addEventListener('click',closeCart)});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeCart();$$('.modal.is-open').forEach(function(m){m.classList.remove('is-open')});if(mm)mm.classList.remove('is-open');lock(false)}});
if(drawer)drawer.addEventListener('click',function(e){
  var b=e.target.closest('[data-q]');if(!b)return;var line=b.closest('[data-key]');line.classList.add('is-busy');
  fetch(JS.routes.cartChange+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:line.getAttribute('data-key'),quantity:parseInt(b.getAttribute('data-q'),10)})})
    .then(function(r){return r.json()}).then(renderCart).catch(function(){line.classList.remove('is-busy')});
});

/* Product */
$$('[data-product]').forEach(function(root){
  var jsonEl=$('[data-product-json]',root);if(!jsonEl)return;
  var product=JSON.parse(jsonEl.textContent),form=$('#product-form',root)||$('form[action*="/cart/add"]',root);
  var input=$('[data-variant-input]',root),atc=$('[data-atc]',root),priceEl=$('[data-price]',root),stickyP=$('[data-sticky-price]',root),err=$('[data-error]',root);
  var opts=$$('[data-option]',root);
  var params=new URLSearchParams(location.search),vid=parseInt(params.get('variant'),10);
  var current=product.variants.filter(function(v){return v.id===vid})[0]||product.variants.filter(function(v){return v.available})[0]||product.variants[0];
  var chosen=current?current.options.slice():[];
  var userPicked=!!vid||product.variants.length===1;

  // Group size values like "EU 42 Mens" into Mens / Womens tabs
  opts.forEach(function(o,oi){
    var wrap=$('[data-values]',o),tabs=$('[data-tabs]',o),btns=$$('[data-value]',wrap);
    var re=/^(.*?)\s*(\d+(?:[.,]5)?)\s+(Mens|Womens|Men|Women|Unisex)$/i,groups={},order=[];
    var ok=btns.length>1&&btns.every(function(b){return re.test(b.getAttribute('data-value'))});
    if(!ok){if(btns.some(function(b){return b.textContent.trim().length>4}))wrap.classList.add('is-text');return}
    btns.forEach(function(b){var m=b.getAttribute('data-value').match(re),g=m[3];if(!groups[g]){groups[g]=[];order.push(g)}groups[g].push(b);b.textContent=m[2];b.setAttribute('data-group',g)});
    if(order.length<2)return;
    tabs.hidden=false;
    var active=(chosen[oi]||'').match(re);active=active?active[3]:order[0];
    function show(g){btns.forEach(function(b){b.hidden=b.getAttribute('data-group')!==g});$$('button',tabs).forEach(function(t){t.classList.toggle('is-on',t.getAttribute('data-g')===g)})}
    tabs.innerHTML=order.map(function(g){return '<button type="button" data-g="'+esc(g)+'">'+esc(g)+'</button>'}).join('');
    $$('button',tabs).forEach(function(t){t.addEventListener('click',function(){show(t.getAttribute('data-g'))})});
    show(active);
  });

  function find(){return product.variants.filter(function(v){return v.options.every(function(x,i){return x===chosen[i]})})[0]}
  function refresh(){
    var v=find();
    opts.forEach(function(o,oi){
      var lbl=$('[data-option-label]',o);if(lbl)lbl.textContent=userPicked?chosen[oi]:'Select';
      $$('[data-value]',o).forEach(function(b){
        var val=b.getAttribute('data-value');b.classList.toggle('is-on',userPicked&&val===chosen[oi]);
        var test=chosen.slice();test[oi]=val;
        var match=product.variants.filter(function(x){return x.options.every(function(y,i){return y===test[i]})})[0];
        b.classList.toggle('is-unavailable',!match||!match.available);
      });
    });
    if(v){
      input.value=v.id;priceEl.textContent=money(v.price);if(stickyP)stickyP.textContent=money(v.price);
      atc.disabled=!v.available;atc.textContent=v.available?(userPicked?'Add to bag':'Select a size'):'Sold out';
      if(userPicked&&product.variants.length>1)history.replaceState(null,'',location.pathname+'?variant='+v.id);
      if(v.featured_media)goToMedia(v.featured_media.id);
    } else {atc.disabled=true;atc.textContent='Unavailable'}
  }
  opts.forEach(function(o,oi){$$('[data-value]',o).forEach(function(b){b.addEventListener('click',function(){chosen[oi]=b.getAttribute('data-value');userPicked=true;if(err)err.hidden=true;refresh()})})});

  // quantity
  var qi=$('[data-qty-input]',root);
  $$('[data-qty]',root).forEach(function(b){b.addEventListener('click',function(){qi.value=Math.max(1,(parseInt(qi.value,10)||1)+parseInt(b.getAttribute('data-qty'),10))})});

  // add to bag (AJAX)
  if(form)form.addEventListener('submit',function(e){
    e.preventDefault();
    if(!userPicked&&opts.length){if(err){err.textContent='Please select a size.';err.hidden=false}opts[0].scrollIntoView?window.scrollTo({top:opts[0].getBoundingClientRect().top+window.scrollY-140,behavior:'smooth'}):0;return}
    atc.disabled=true;var label=atc.textContent;atc.textContent='Adding…';
    fetch(JS.routes.cartAdd+'.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(function(){atc.textContent='Added to bag';openCart();setTimeout(function(){atc.textContent=label;atc.disabled=false},1800)})
      .catch(function(j){atc.disabled=false;atc.textContent=label;if(err){err.textContent=(j&&(j.description||j.message))||'Could not add to bag.';err.hidden=false}});
  });

  // sticky ATC
  var sticky=$('[data-sticky-atc]',root),sbtn=$('[data-sticky-btn]',root);
  if(sticky&&atc&&'IntersectionObserver' in window){new IntersectionObserver(function(es){sticky.classList.toggle('is-on',!es[0].isIntersecting&&es[0].boundingClientRect.top<0)}).observe(atc)}
  if(sbtn)sbtn.addEventListener('click',function(){if(form.requestSubmit)form.requestSubmit();else atc.click()});

  // gallery
  var track=$('[data-track]',root),slides=$$('.pdp__slide',root),thumbs=$$('[data-thumb]',root),counter=$('[data-counter]',root),dots=$$('.pdp__dots i',root),gi=0;
  function pad(x){return (x<10?'0':'')+x}
  function mark(i){gi=i;thumbs.forEach(function(t,k){t.classList.toggle('is-on',k===i)});dots.forEach(function(d,k){d.classList.toggle('is-on',k===i)});if(counter)counter.textContent=pad(i+1)+' / '+pad(slides.length);
    $$('video',root).forEach(function(v,k){if(!slides[i].contains(v))v.pause()});var vv=$('video',slides[i]);if(vv&&mq.matches)vv.play&&vv.play().catch(function(){})}
  function go(i){if(!slides.length)return;i=(i+slides.length)%slides.length;$$('.pdp__zoom.is-zoomed',root).forEach(function(z){z.classList.remove('is-zoomed')});
    if(mq.matches)track.style.transform='translateX('+(-100*i)+'%)';else track.scrollTo({left:track.clientWidth*i,behavior:'smooth'});mark(i)}
  function goToMedia(id){var k=slides.findIndex?slides.findIndex(function(s){return String(s.getAttribute('data-media-id'))===String(id)}):-1;if(k>-1&&k!==gi)go(k)}
  thumbs.forEach(function(t){t.addEventListener('click',function(){go(parseInt(t.getAttribute('data-thumb'),10))})});
  var pv=$('[data-prev]',root),nx=$('[data-next]',root);pv&&pv.addEventListener('click',function(){go(gi-1)});nx&&nx.addEventListener('click',function(){go(gi+1)});
  if(track)track.addEventListener('scroll',function(){if(mq.matches)return;var i=Math.round(track.scrollLeft/track.clientWidth);if(i!==gi)mark(i)},{passive:true});
  mq.addEventListener&&mq.addEventListener('change',function(){track.style.transform='';go(gi)});
  $$('[data-zoom]',root).forEach(function(z){var im=$('img',z);
    z.addEventListener('click',function(e){if(!mq.matches)return;z.classList.toggle('is-zoomed');move(e)});
    function move(e){if(!z.classList.contains('is-zoomed'))return;var r=z.getBoundingClientRect();im.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%'}
    z.addEventListener('mousemove',move);z.addEventListener('mouseleave',function(){z.classList.remove('is-zoomed')});
  });
  document.addEventListener('keydown',function(e){if(!mq.matches||/input|textarea|select/i.test(document.activeElement.tagName))return;if(e.key==='ArrowRight')go(gi+1);if(e.key==='ArrowLeft')go(gi-1)});
  refresh();
});

/* Recommendations */
$$('[data-recs]').forEach(function(el){
  var u=el.getAttribute('data-url');if(!u)return;
  fetch(u).then(function(r){return r.text()}).then(function(t){var d=document.createElement('div');d.innerHTML=t;var n=d.querySelector('[data-recs]');if(n&&n.innerHTML.trim())el.innerHTML=n.innerHTML});
});

/* Collection filters & sort */
var facets=$('[data-facets]');
if(facets){
  var submit=function(){var fd=new FormData(facets),p=new URLSearchParams();fd.forEach(function(v,k){if(v!=='')p.append(k,v)});location.href=facets.getAttribute('action')+'?'+p.toString()};
  facets.addEventListener('change',function(e){if(e.target.type==='number')return;submit()});
  facets.addEventListener('submit',function(e){e.preventDefault();submit()});
  var tg=$('[data-facets-toggle]');tg&&tg.addEventListener('click',function(){facets.classList.toggle('is-open')});
  $$('[data-facet]').forEach(function(d){d.addEventListener('toggle',function(){if(d.open&&mq.matches)$$('[data-facet]').forEach(function(o){if(o!==d)o.open=false})})});
  document.addEventListener('click',function(e){if(mq.matches&&!e.target.closest('[data-facet]'))$$('[data-facet]').forEach(function(o){o.open=false})});
}

/* Load more */
document.addEventListener('click',function(e){
  var a=e.target.closest('[data-load-more]');if(!a)return;e.preventDefault();a.textContent='Loading…';
  fetch(a.href).then(function(r){return r.text()}).then(function(t){
    var d=document.createElement('div');d.innerHTML=t;var grids=$$('[data-grid]'),target=grids[grids.length-1];
    $$('[data-grid] .card',d).forEach(function(c){target.appendChild(c)});
    var next=d.querySelector('[data-load-more]'),wrap=a.closest('.loadmore'),info=d.querySelector('.loadmore .eyebrow');
    if(info&&wrap.querySelector('.eyebrow'))wrap.querySelector('.eyebrow').textContent=info.textContent;
    if(next){a.href=next.href;a.textContent='Load more'}else a.remove();
    history.replaceState(null,'',a.href||location.href);
  });
});
})();
